import React from "react";
import { useHistory } from "react-router-dom";
import {
  ListSubheader,
  makeStyles,
  List,
  SwipeableDrawer,
  ListItemIcon,
  ListItemText,
  MenuItem,
  useTheme,
  Divider,
} from "@material-ui/core";
import Logo from "../../config/Logo";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import SpeakerNotesOutlinedIcon from "@material-ui/icons/SpeakerNotesOutlined";
import LoginIcon from "@material-ui/icons/AccountCircle";
import ExternalIcon from "@material-ui/icons/Language";
import hexToRgba from "hex-to-rgba";
import Footer from "./Footer";

const drawerWidth = 290;

const useStyles = makeStyles((theme) => ({
  menuItemStyle: {
    marginRight: 15,
    marginLeft: 15,
    marginTop: 4,
    marginBottom: 4,
    borderRadius: "0.4em",
    color: "black",
    "& .MuiListItemText-primary": {
      fontWeight: 500,
    },
    "& .MuiTouchRipple-root": {
      color: theme.palette.primary.main,
    },
    "&:focus": {
      backgroundColor: "white",
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.primary.main,
      },
    },
    "&.Mui-selected": {
      backgroundColor: hexToRgba(theme.palette.primary.main, 0.25),
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.primary.main,
        fontWeight: 600,
      },
    },
  },
  list: {
    width: drawerWidth,
    overflowY: "auto",
    height: "100%",
  },
  divider: {
    marginTop: "1em",
  },
  wpbar: {
    top: 32,
  },
}));

const DrawerItem = ({ title, icon, path, onClick }) => {
  const history = useHistory();
  const classes = useStyles();

  return (
    <MenuItem
      onClick={onClick}
      className={classes.menuItemStyle}
      selected={history.location.pathname === path}
    >
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primary={title} />
    </MenuItem>
  );
};

let wpbar = document.getElementsByClassName("admin-bar").length > 0;

const NavigationDrawer = ({ open, onClose, onOpen }) => {
  const classes = useStyles();
  const theme = useTheme();

  const history = useHistory();

  const loginUrl = `${window.AppInfo.loginUrl}${
    window.AppInfo.isUserLogedIn ? "&" : "?"
  }redirect_to=/`;

  return (
    <SwipeableDrawer
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      classes={wpbar ? { paper: classes.wpbar } : {}}
    >
      {window.AppInfo.logoImage && (
        <>
          <div style={{ padding: theme.spacing(2) }}>
            <Logo size={40} />
          </div>
          <Divider />
        </>
      )}
      <List className={classes.list}>
        <ListSubheader>
          {window.t["Pages"]}
          <Divider />
        </ListSubheader>
        <DrawerItem
          title={window.t["Dashboard"]}
          icon={<DashboardOutlinedIcon />}
          path="/"
          onClick={() => {
            history.push("/");
            onClose();
          }}
        />
        {window.AppInfo.showNews && (
          <DrawerItem
            title={window.t["News"]}
            icon={<SpeakerNotesOutlinedIcon />}
            path="/news"
            onClick={() => {
              history.push("/news");
              onClose();
            }}
          />
        )}
        {window.AppInfo.appMenu.length > 0 && (
          <>
            <ListSubheader> {window.AppInfo.menuName} </ListSubheader>
            <Divider />
            {window.AppInfo.appMenu.map((e, k) => (
              <DrawerItem
                key={k + "icon"}
                icon={<ExternalIcon />}
                title={e?.title || ""}
                onClick={() => {
                  window.location.replace(e.url);
                }}
              />
            ))}
          </>
        )}
      </List>
      <Footer text={window.t["Company Portal Developed by"]}>
        <List className={classes.list}>
          <ListSubheader>
            <Divider />
          </ListSubheader>
          <DrawerItem
            title={
              window.AppInfo.isUserLogedIn
                ? window.t["Logout"]
                : window.t["Login"]
            }
            icon={<LoginIcon />}
            onClick={() => {
              window.location.replace(loginUrl);
            }}
          />
        </List>
      </Footer>
    </SwipeableDrawer>
  );
};

export default NavigationDrawer;
